var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.278 51.6463C26.278 51.6463 9.33337 37.3757 9.33337 23.3337C9.33337 18.383 11.3 13.635 14.8007 10.1343C18.3014 6.63365 23.0493 4.66699 28 4.66699C32.9507 4.66699 37.6987 6.63365 41.1994 10.1343C44.7 13.635 46.6667 18.383 46.6667 23.3337C46.6667 37.3757 29.722 51.6463 29.722 51.6463C28.7794 52.5143 27.2277 52.505 26.278 51.6463ZM28 31.5003C29.0725 31.5003 30.1345 31.2891 31.1253 30.8787C32.1161 30.4683 33.0164 29.8667 33.7747 29.1084C34.5331 28.35 35.1346 27.4497 35.5451 26.4589C35.9555 25.4681 36.1667 24.4061 36.1667 23.3337C36.1667 22.2612 35.9555 21.1992 35.5451 20.2084C35.1346 19.2176 34.5331 18.3173 33.7747 17.559C33.0164 16.8006 32.1161 16.1991 31.1253 15.7886C30.1345 15.3782 29.0725 15.167 28 15.167C25.8341 15.167 23.7569 16.0274 22.2253 17.559C20.6938 19.0905 19.8334 21.1677 19.8334 23.3337C19.8334 25.4996 20.6938 27.5768 22.2253 29.1084C23.7569 30.6399 25.8341 31.5003 28 31.5003Z",
    fill: "#0E228B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c3efc70def656a23a92d3f7bcbb7bbc2.svg";
export { ForwardRef as ReactComponent };